import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";

const fetchCollections = async (payload) => {
  const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getCollections`, payload);
  return response.data;
};

const useGetCollections = (payload) => {
  return useQuery({
    queryKey: ["collections", payload],
    queryFn: () => fetchCollections(payload),
    enabled: !!payload,
    refetchOnWindowFocus: false,
  });
};

export default useGetCollections;
